import React, { useState, useEffect, useCallback, useRef, useMemo } from 'react';
import {renderRoutes} from 'react-router-config';
import { useDispatch, useSelector} from 'react-redux'
import { makeStyles, useTheme } from '@material-ui/core/styles';
import { Table, TableHead, TableBody, TableCell, TableContainer, TableFooter, TablePagination, TableRow} from '@material-ui/core';
import Paper from '@material-ui/core/Paper';
import Divider from '@material-ui/core/Divider';
import { Card, Button, TextField, Typography, Input, InputAdornment, OutlinedInput, Fab } from '@material-ui/core';
import Autocomplete from '@material-ui/lab/Autocomplete';
import { Search } from '@material-ui/icons';
import _ from 'lodash';
import TablePaginationActions from '../common/TablePaginationActions';
import EditDriverInfo from './update';
import AddDriverInfo from './add';
import { getDriverList, getBasicInfo, getWorkingArea } from '../../actions/driverActions';


const useStyles = makeStyles((theme)=> ({
  root: {
    flexGrow: 1,
  },
  paper: {
    padding: theme.spacing(2),    
    textAlign: 'center',
    color: theme.palette.text.secondary,
  },    
  table: {
    minWidth: 700,
    border: 1,    
  },  
}))

const driverTypeList = [
  { label: 'ALL', value: 9 },
  { label: 'service number', value: 1 },
  { label: 'full time driver', value: -1 },
  { label: 'self employee driver', value: 0 },
];
const driverStatusList = [
  { label: '全部', value: 9 },
  { label: '在职', value: 1 },
  { label: '离职', value: 0 },
];

const DEFAULT_CITY_ID = 1;
const DEFAULT_DRIVER_TYPE = 9;
const DEFAULT_DRIVER_STATUS = 9;
const SERVICE_NUMBER = 1;
const FULL_TIME_DRIVER = -1;
const SELF_EMPLOYEE_DRIVER = 0;
const DEFAULT_START_PAGE = 0;
const DEFAULT_ROWS_PER_PAGE = 10;
const DRIVER_TYPE_ALL = 9;
const IS_HIRED_ALL = 9;

export default function DriverList(props) {

  const { route } = props
  const classes = useStyles();
  const dispatch = useDispatch();

  const paginationRef= useRef();
  const area = useSelector(state => state.driver.area);
  const pageTotal = useSelector(state => state.driver.pageTotal);

  //Row change
  const [page, setPage] = React.useState(DEFAULT_START_PAGE);
  const [rowsPerPage, setRowsPerPage] = React.useState(DEFAULT_ROWS_PER_PAGE);    
  const emptyRows = rowsPerPage - Math.min(rowsPerPage, pageTotal - page * rowsPerPage);
  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };

  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(parseInt(event.target.value, DEFAULT_ROWS_PER_PAGE));
    setPage(0);
  };

  const driverList = useSelector(state => state.driver.driverList) || [];
  const driverAddStatus = useSelector(state => state.driver.driverAddStatus);  //the data shoud be recall if it's changed
  const driverUpdatStatus = useSelector(state => state.driver.driverUpdatStatus);

  const [driverId,setDriverId] = useState("");
  const [cityId,setCityId] = useState("");

  const [driverType,setDriverType] = useState(DEFAULT_DRIVER_TYPE);
  const [driverStatus,setDriverStatus] = useState(DEFAULT_DRIVER_STATUS);
  const [queryCondition,setQueryCondition] = useState({area: area, page: page + 1, size: rowsPerPage});
 
  // operation type
  const [isAdd,setIsAdd] = useState(false);
  const [isEdit,setIsEdit] = useState(false);

  /**
   * prevent the frequency response when the use input the drive id ,as the system will 
   * automatic send request to the backend to get the specific driver recorder
   */
  const delaySearch = useCallback(_.debounce(value=>setQueryCondition(value), 350), []);
  
  //get the basic info such as salary type from the database
  useEffect(() => {
    dispatch(getBasicInfo());
    dispatch(getWorkingArea());
  },[]);

  //const [subProps,setSubProps] = useState();
  //refresh the data recorder when user change the current page or query condition
  useEffect(() => {
      setQueryCondition({...queryCondition,page: page+1, size: rowsPerPage});
      //dispatch(getDriverList(...queryCondition,{page:page+1}));  
      //console.log("------queryCondition: ",queryCondition);
      //setSubProps({count: pageTotal, page: page, rowsPerPage: rowsPerPage, onChangePage: (newPage)=>setPage(newPage)})
  }, [page,rowsPerPage]);

  useEffect(() => {
    dispatch(getDriverList(queryCondition));  
}, [queryCondition]);

  //refresh when user successfuly add or edit a recorder
  useEffect(() => {
    if (driverAddStatus==="SUCCESS" || driverUpdatStatus==="SUCCESS") {
      dispatch(getDriverList({area: area, page: page + 1, size: rowsPerPage}));  
    }
}, [driverAddStatus,driverUpdatStatus]);

  return (
    <div className={classes.root} >
      {renderRoutes(route.routes)}

      <Card >
        <form style={{display: 'flex', flexDirection: 'row', padding: 16}}>
          <div style={{paddingRight: 16}}>
            <OutlinedInput style={{marginLeft: "yes" , width: '350px'}}
                startAdornment={
                    <InputAdornment position='start'>
                        <Search />
                    </InputAdornment>
                }
                placeholder="Search"
                onChange={handleSearchChange} 
            />
          </div>
          <Button variant="contained" color="primary" style={{paddingLeft: 16}} onClick={handleAddDriver}>添加司机</Button>
        </form>
        <form style={{display: 'flex', flexDirection: 'row', padding: 16}}>
          <Autocomplete 
            id="driverType"
            size="small"
            options={driverTypeList}
            getOptionLabel={(option) => option.label}
            onChange={handleDriverTypeChange}
            renderInput={(params) => (
              <TextField {...params} variant="outlined" label="司机类型" />
            )}
            style={{width: '350px', paddingRight: 16}}
          />                 
          <Autocomplete 
              id="driverStatus"
              size="small"
              options={driverStatusList}
              getOptionLabel={(option) => option.label}
              onChange={handleDriverStatusChange}
              renderInput={(params) => (
                <TextField {...params} variant="outlined" label="司机状态" />
              )}
              style={{width: '350px'}}
            /> 
        </form>
      </Card>

      <Divider></Divider>      
      <TableContainer component={Paper} style = {{paddingTop: 16}}>
        <Table className={classes.table} >
          <TableHead>
            <TableRow>
              <TableCell align="center">ID</TableCell>
              <TableCell align="center">用户名</TableCell>
              <TableCell align="center">电话</TableCell>
              <TableCell align="center">姓</TableCell>
              <TableCell align="center">名</TableCell>
              <TableCell align="center">工作区域</TableCell>
              <TableCell align="center">操作</TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {
            // (rowsPerPage > 0
            //   ? driverList.slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
            //   : driverList
              (driverList
            ).map((row) => (
                <TableRow key={row.name}>
                <TableCell align="center">{row.id}</TableCell>
                <TableCell align="center">{row.name}</TableCell>
                <TableCell align="center">{row.phone}</TableCell>
                <TableCell align="center">{row.lastname}</TableCell>
                <TableCell align="center">{row.firstname}</TableCell>      
                <TableCell align="center">{row.workingarea}</TableCell>
                <TableCell align="center">
                  <button 
                    onClick = {()=>{handleEditDriver(row.id,row.city_id)}}>编辑
                  </button>                  
                </TableCell>
              </TableRow>
            ))}
            {emptyRows > 0 && (
              <TableRow style={{ height: 53 * emptyRows }}>
                <TableCell colSpan={6} />
              </TableRow>
            )}
          </TableBody>
          <TableFooter >
            <TableRow style={{align: "right"}}>
              <TablePagination 
                rowsPerPageOptions={[10, 15, 20, { label: 'All', value: -1 }]}
                colSpan={3}
                count={pageTotal}
                rowsPerPage={rowsPerPage}
                page={page}
                SelectProps={{
                  inputProps: { 'aria-label': 'rows per page' },
                  native: true,
                }}
                onChangePage={handleChangePage}
                onChangeRowsPerPage={handleChangeRowsPerPage}
                //ActionsComponent={(subProps)=> <TablePaginationActions ref={paginationRef} {...subProps}/>}
                ActionsComponent={TablePaginationActions}                
              />
              
            </TableRow>
          </TableFooter>
        </Table>
      </TableContainer>
      { 
        isEdit ?
        <EditDriverInfo openModal={isEdit} driverId={driverId} cityId={cityId} onEditClose={handleCloseEditDriver} />
        : null
      }
      {
        isAdd ?
        <AddDriverInfo openModal={isAdd} onAddClose={handleCloseAddDriver}/> 
        : null
      }
    </div>
  );


  /**
   * search by the sepcific driverId as the user input 
   * @param {*} event 
   */
  function handleSearchChange(event){
        //init 
        if (event.target.value === "")  {
          delaySearch({
            area: area, 
            page: page + 1, 
            size: rowsPerPage,
          });  
        } else {
          delaySearch({
            area: area, 
            page: page + 1, 
            size: rowsPerPage,
            driver_id: event.target.value
          });  
        } 
  }
  
  /**
   * change the query condition when the user choose the dirver type
   * @param {*} event 
   * @param {*} newOption 
   */
  function handleDriverTypeChange(event,newOption) {        
    let code = DRIVER_TYPE_ALL;

    if(typeof newOption == "undefined" || newOption === null || newOption === ""){
      //code = 9;
    } else {
      code = newOption.value;
    }
    setDriverType(code);

    handleDriverListFilter(code,driverStatus);
  }

  /**
   * change the query condition when the user choose the dirver status
   * @param {*} event 
   * @param {*} newOption 
   */
  function handleDriverStatusChange(event,newOption) {
    let code = IS_HIRED_ALL;

    if(typeof newOption == "undefined" || newOption === null || newOption === ""){
      //code = 9;
    } else {
      code = newOption.value;
    }
    setDriverStatus(code);

    handleDriverListFilter(driverType,code);
  }

  /**
   * merge the query condition based the driver type and drver status.
   * and the query condition will be automatic execut when the system notice
   * @param {me} driverType 
   * @param {*} driverStatus 
   * @param {*} search 
   */
  function handleDriverListFilter(driverType,driverStatus) {
    //init
    //let obj = {};
    let obj = {area: area, page: page + 1, size: rowsPerPage};

    // add filter param according to driver type
    if (driverType === SERVICE_NUMBER ) {  //服务号
      obj['virtual'] = SERVICE_NUMBER;
    } else if (driverType === FULL_TIME_DRIVER) {  //真实司机(9开头)
      obj['role'] = FULL_TIME_DRIVER;
    } else if (driverType === SELF_EMPLOYEE_DRIVER) { //真实司机(非9开头)
      obj['role'] = SELF_EMPLOYEE_DRIVER;
    } else { //全部

    }

    // add filter param according to driver status
    if (driverStatus !== IS_HIRED_ALL) { 
      obj['is_hired'] = driverStatus;
    } 

    setQueryCondition(obj);    
  }

  /**
   * notify the system to open the add dialog
   */
  function handleAddDriver() {
    setIsAdd(true);    
  }

  /**
   * notify the system to close the add dialog
   */
  function handleCloseAddDriver() {
    setIsAdd(false);
  }

  /**
   * notify the system to open the update dialog
   */
  function handleEditDriver(driverId,cityId) {
    setDriverId(driverId);
    setCityId(cityId);
    setIsEdit(true);    
  }

  /**
   * notify the system to close the update dialog
   */
  function handleCloseEditDriver() {
    setIsEdit(false);
  }

}
